const scale = 1.5;

export const captureOptions = {
  scenario: {
    x: 0,
    y: 0,
    width: 1020,
    height: 780,
    scale,
  },
  summaryCalculations: {
    x: 0,
    y: 0,
    width: 1020,
    height: 700,
    scale,
  },
  programmingWorksheet: {
    x: 0,
    y: 0,
    width: 1090,
    height: 144, // absolute, minimum height of worksheet data
    scale,
  },
  spaceTypeMix: {
    x: 0,
    y: 0,
    width: 1000,
    height: 800,
    scale,
  },
  spaceTypeMixDetails: {
    x: 0,
    y: 0,
    width: 1000,
    height: 800,
    scale,
  },
  workSettingsMix: {
    x: 0,
    y: 0,
    width: 975,
    height: 800,
    scale,
  },
  usfSpaceCat: {
    x: 0,
    y: 0,
    width: 550,
    height: 450,
    scale,
  },
  densityWorkSeat: {
    x: 60,
    y: 0,
    width: 400,
    height: 450,
    scale,
  },
  headcountDensityCard: {
    x: 60,
    y: 0,
    width: 400,
    height: 450,
    scale,
  },
  usfSpaceCatProgramming: {
    x: 0,
    y: 0,
    width: 550,
    height: 500,
    scale,
  },
  spaceBreakdownIcon: {
    x: 0,
    y: -10,
    width: 270,
    height: 210,
    scale,
  },
  keyData: {
    x: 60,
    y: 0,
    width: 400,
    height: 450,
    scale,
  },
  keyDataProgramming: {
    x: 60,
    y: 0,
    width: 400,
    height: 500,
    scale,
  },
  programDelta: {
    x: 60,
    y: 0,
    width: 400,
    height: 450,
    scale,
  },
  occupancyUtilizationSummary: {
    x: 0,
    y: 0,
    width: 500,
    height: 500,
    scale: 1,
  },
  programSummaryCategoryRow: {
    x: 0,
    y: 0,
    width: 1440,
    height: 180,
    scale,
  },
  esaProgramSummaryCategoryRow: {
    x: 0,
    y: 0,
    width: 1440,
    scale: 1.5,
  },
  singlePageSummary: {
    x: 0,
    y: 0,
    width: 1440,
    height: 600,
    scale,
  },
  keyDataMacro: {
    x: 0,
    y: 0,
    width: 515,
    height: 470,
    scale,
  },
  worksheetNote: {
    x: 0,
    y: 0,
    width: 1090,
    height: 50,
    scale,
  },
};
